import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOverdraft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.0806 16.2416C13.4689 19.4717 10.5311 13.1861 3.91941 16.4162V7.75842C10.5311 4.52835 13.4689 10.8139 20.0806 7.58382V16.2416Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 13.7315C12.9563 13.7315 13.7316 12.9563 13.7316 12C13.7316 11.0437 12.9563 10.2684 12 10.2684C11.0437 10.2684 10.2684 11.0437 10.2684 12C10.2684 12.9563 11.0437 13.7315 12 13.7315Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgOverdraft;
